//@flow
import * as Immutable from 'immutable';
import { createSelector, type OutputSelector } from 'reselect';

import {
    BusinessUnitList,
    BusinessUnit
} from 'common/models/internal/BusinessUnits';

import { clientIdSelector } from 'common/redux/selectors/sessionSelector';
import { personnelActiveTeamsSelector } from 'common/redux/selectors/personnelTeamsSelector';
import { getSelectedBUId } from 'common/redux/selectors/appPreferences';

import { type AppState } from 'common/redux/reducers';

type Props = { match: Object };

export const clientBusinessUnitsSelector: OutputSelector<
    AppState,
    Props,
    BusinessUnitList
> = createSelector(
    [state => state.businessUnits, clientIdSelector],
    (businessUnitDetails, clientId) => {
        return businessUnitDetails.getIn(
            ['records', clientId, 'businessUnits'],
            BusinessUnitList.fromJS({ businessUnits: [] })
        );
    }
);

export const personnelBUsSelector: OutputSelector<
    AppState,
    Props,
    Immutable.List<BusinessUnit>
> = createSelector(
    [clientBusinessUnitsSelector, personnelActiveTeamsSelector],
    (clientBUs, teams) => {
        return clientBUs.businessUnits.filter(businessUnit =>
            teams.some(
                team =>
                    team.businessUnitId &&
                    team.businessUnitId.businessUnitId ===
                        businessUnit.businessUnitId
            )
        );
    }
);

export const getSelectedBusinessUnit: OutputSelector<
    AppState,
    Props,
    ?BusinessUnit
> = createSelector(
    [personnelBUsSelector, getSelectedBUId],
    (businessUnits, selectedBUId) => {
        return businessUnits.find(bu => bu.businessUnitId === selectedBUId);
    }
);

export const isBULoadingSelector: OutputSelector<
    AppState,
    Props,
    boolean
> = createSelector(
    [state => state.businessUnits, clientIdSelector],
    (businessUnitDetails, clientId) => {
        return businessUnitDetails.getIn(
            ['records', clientId, 'isBULoading'],
            true
        );
    }
);
